module.exports = __webpack_public_path__ + "img/alterna-icon@2x.0132f2e0.png";